export default __webpack_public_path__ + "static/media/first-triangles.64490007.png";